module.exports = __webpack_public_path__ + "img/bginfo.9ab1364d.png";